import React, { useMemo } from 'react';
import Table from '../Table';
import SearchTable from '../SearchTable';

export default function Races(props) {
    const isSearchTable = props.searchTable;
    const TableComponent = isSearchTable ? SearchTable : Table;

    const columns = useMemo(
        () => [
            {
                Header: 'Country',
                accessor: 'country',
                Cell: props => {
                    if (props.value) {
                        return (
                            <div className="flag proxima">
                                <img
                                    src={`${theme_details.templateUrl}/svgs/${props.value.toLowerCase()}.svg`}
                                    width="34"
                                    height="42"
                                    alt={props.value}
                                    title={props.row.original.country_name}
                                />
                                {props.row.original.iso}
                            </div>
                        );
                    } else {
                        return '';
                    }
                },
            },
            {
                Header: 'Race Name',
                accessor: 'title',
                Cell: props => (
                    <a href={props.row.original.url}>
                        <p className="database-table__title">{props.value}</p>
                        <p className="database-table__subtitle proxima">{props.row.original.subtitle}</p>
                    </a>
                ),
            },
            {
                Header: 'Date',
                accessor: 'race_date',
                Cell: props => (
                    <p className="database-table__subtitle proxima">
                        {isSearchTable ? props.row.original.race_date_str : props.value}
                    </p>
                ),
                sortType: 'datetime',
            },
            {
                Header: 'Championship',
                accessor: 'championship_type',
                only_desktop: true,
                Cell: props => (
                    <p className="database-table__title">
                        <a href={props.row.original.championship_type_link}>{props.value}</a>
                    </p>
                ),
            },
            {
                Header: 'Winners',
                accessor: 'race_winner',
                only_desktop: true,
                Cell: props => (
                    props.value.map((value, index) => {
                        if (value.url !== '') {
                            return <p className={value.css_class} key={index}><a href={value.url}>{value.name}</a></p>;
                        } else {
                            return <p className={value.css_class} key={index}>{value.name}</p>;
                        }
                    })
                ),
            },
        ],
        [],
    );

    return <TableComponent columns={columns} {...props} />;
}
